var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7h16v16H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.333,
    d: "M20.364 8.636a.429.429 0 0 1 0 .606L14.606 15l5.758 5.758a.429.429 0 0 1 .055.538l-.055.068a.429.429 0 0 1-.606 0L14 15.606l-5.758 5.758a.429.429 0 0 1-.606-.606L13.394 15 7.636 9.242a.429.429 0 0 1-.055-.538l.055-.068a.429.429 0 0 1 .606 0L14 14.394l5.758-5.758a.429.429 0 0 1 .606 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/closeWhite.6e73d65f1cdd1ca6cf0cf91605843f65.svg";
export { ForwardRef as ReactComponent };